/**
 * ドライバ管理会社ID一覧
 */
// 静鉄タクシー株式会社
export const DRIVER_MANAGE_COMPANY_ID_SHIZUOKA_RAILWAY_TAXI: string = '1';

// 丸新交通株式会社
export const DRIVER_MANAGE_COMPANY_ID_MARUSHIN_TRANSPORTATION: string = '2';

// 志太交通株式会社
export const DRIVER_MANAGE_COMPANY_ID_SHIDA_KOTSU: string = '3';

// 確認用CMドライバ管理会社
export const DRIVER_MANAGE_COMPANY_ID_CONFIRM_CM_DRIVER: string = '4';

// (リリース後確認用）ＣＭドライバ管理会社
export const DRIVER_MANAGE_COMPANY_ID_RELEASE_CONFIRM_CM_DRIVER: string = '5';

// デジ田用ドライバ管理会社
export const DRIVER_MANAGE_COMPANY_ID_DIGIDEN: string = '6';

// 植松タクシー有限会社
export const DRIVER_MANAGE_COMPANY_ID_UMEMATSU_TAXI: string = '7';

// 登坂タクシー有限会社
export const DRIVER_MANAGE_COMPANY_ID_TOBISAKA_TAXI: string = '8';

// 大曽根タクシー株式会社
export const DRIVER_MANAGE_COMPANY_ID_OOSONE_TAXI: string = '9';

// 新栄タクシー有限会社
export const DRIVER_MANAGE_COMPANY_ID_SHINEI_TAXI: string = '10';

// 株式会社フジ急
export const DRIVER_MANAGE_COMPANY_ID_FUJI_KYUU: string = '11';

// 有限会社旭タクシー
export const DRIVER_MANAGE_COMPANY_ID_ASAHI_TAXI: string = '12';

// 株式会社上郷タクシー
export const DRIVER_MANAGE_COMPANY_ID_KAMIGO_TAXI: string = '13';

// 新興タクシー有限会社
export const DRIVER_MANAGE_COMPANY_ID_SHINKOU_TAXI: string = '14';

// 土浦タクシー株式会社
export const DRIVER_MANAGE_COMPANY_ID_TTUCHIURA_TAXI: string = '15';

// 関鉄タクシー株式会社
export const DRIVER_MANAGE_COMPANY_ID_KANTETSUS_TAXI: string = '16';

// 有限会社天川タクシー
export const DRIVER_MANAGE_COMPANY_ID_TENKAWA_TAXI: string = '17';

// 有限会社佐藤タクシー
export const DRIVER_MANAGE_COMPANY_ID_SATOU_TAXI: string = '18';

// 藤枝エリアリスト
export const FUJIEDA_AREA_LIST: string[] = [
  DRIVER_MANAGE_COMPANY_ID_SHIZUOKA_RAILWAY_TAXI,
  DRIVER_MANAGE_COMPANY_ID_MARUSHIN_TRANSPORTATION,
  DRIVER_MANAGE_COMPANY_ID_SHIDA_KOTSU,
  DRIVER_MANAGE_COMPANY_ID_CONFIRM_CM_DRIVER,
  DRIVER_MANAGE_COMPANY_ID_RELEASE_CONFIRM_CM_DRIVER,
];

// デジ田エリアリスト
export const DIGIDEN_AREA_LIST: string[] = [DRIVER_MANAGE_COMPANY_ID_DIGIDEN];

// つくタクエリアリスト
export const TSUKUTAKU_AREA_LIST: string[] = [
  DRIVER_MANAGE_COMPANY_ID_UMEMATSU_TAXI,
  DRIVER_MANAGE_COMPANY_ID_TOBISAKA_TAXI,
  DRIVER_MANAGE_COMPANY_ID_OOSONE_TAXI,
  DRIVER_MANAGE_COMPANY_ID_SHINEI_TAXI,
  DRIVER_MANAGE_COMPANY_ID_FUJI_KYUU,
  DRIVER_MANAGE_COMPANY_ID_ASAHI_TAXI,
  DRIVER_MANAGE_COMPANY_ID_KAMIGO_TAXI,
  DRIVER_MANAGE_COMPANY_ID_SHINKOU_TAXI,
  DRIVER_MANAGE_COMPANY_ID_TTUCHIURA_TAXI,
  DRIVER_MANAGE_COMPANY_ID_KANTETSUS_TAXI,
  DRIVER_MANAGE_COMPANY_ID_TENKAWA_TAXI,
  DRIVER_MANAGE_COMPANY_ID_SATOU_TAXI,
];

/**
 * テナントデータ一覧
 */
// つくば・土浦エリアの場合
export const AREA_ID_TSUKUBA_TSUPURA: string = '2';
export const AREA_NAME_TSUKUBA_TSUPURA: string = 'つくば・土浦エリア';

// 筑波山エリアの場合
export const AREA_ID_MOUNT_TSUKUBA: string = '3';
export const AREA_NAME_MOUNT_TSUKUBA: string = '筑波山エリア';

// 下妻エリアの場合
export const AREA_ID_SHIMOTSUMA: string = '4';
export const AREA_NAME_SHIMOTSUMA: string = '下妻エリア';

// 牛久エリアの場合
export const AREA_ID_USHIKU: string = '5';
export const AREA_NAME_USHIKU: string = '牛久エリア';

// 検索ボタン種別1：明日
export const SEARCH_TYPE_TOMORROW: string = '1';
// 検索ボタン種別2：今日
export const SEARCH_TYPE_TODAY: string = '2';
// メンテナンスエラーコード
export const MAINTENANCE_ERROR_CODE = 'RSH00001';
// メンテナンスエラーメッセージ
export const MAINTENANCE_ERROR_MESSAGE = 'MAINTENANCE_ERROR_MESSAGE';
